import { Project } from '../data/project/project';


export abstract class ProjectHolder {
   project: Project;
}
